<div class="webhook-grid">

  <div class="flex-direction-column gap-15 webhook-form">
    <div class="label-lateral">
      <span class="label">Aviso de Evento</span>
    </div>

    <app-form-field
      label="URL"
      heightFormField="35px"
      widthFormField="100%"
      placeholder="Digite"
      [carregandoInfo]="carregando()"
      [value]="url()"
      (changeValue)="url.set($event)">
    </app-form-field>

    <app-form-field
      label="Token"
      heightFormField="35px"
      widthFormField="100%"
      placeholder="Digite"
      [carregandoInfo]="carregando()"
      [value]="clienteToken()"
      (changeValue)="clienteToken.set($event)">
    </app-form-field>

    <app-button-padrao
      backgroundColor="var(--verde-padrao)"
      color="white"
      [label]="salvando() ? 'Salvando...' : 'Salvar'"
      width="100%"
      [disabled]="salvando()"
      (buttonClick)="salvarWebHook()">
    </app-button-padrao>
  </div>

  <div class="webhook-json">
    <app-json-editor label="JSON" [value]="payloadFixo" [isEditavel]="false"></app-json-editor>
  </div>

</div>
